import React from 'react';

const NavigationButtons = ({
  currentStep,
  totalSteps,
  onBack,
  onNext,
  onAnalyze,
  loading
}) => {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === totalSteps;

  return (
    <div className="flex justify-between items-center mt-8">
      <button
        onClick={onBack}
        disabled={isFirstStep}
        className={`
          px-6 py-2 rounded-lg font-medium transition-all
          ${isFirstStep
            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }
        `}
      >
        Back
      </button>

      {isLastStep ? (
        <button
          onClick={onAnalyze}
          disabled={loading}
          className="
            px-8 py-2 rounded-lg font-medium
            bg-green-600 text-white hover:bg-green-700
            disabled:bg-green-400 disabled:cursor-not-allowed
            transition-all flex items-center space-x-2
          "
        >
          {loading ? (
            <>
              <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Analyzing...</span>
            </>
          ) : (
            <span>Get Recommendations</span>
          )}
        </button>
      ) : (
        <button
          onClick={onNext}
          className="
            px-6 py-2 rounded-lg font-medium
            bg-blue-600 text-white hover:bg-blue-700
            transition-all
          "
        >
          Next
        </button>
      )}
    </div>
  );
};

export default NavigationButtons;
